/**
 * Shared ISO date validation (admin-frontend UX tier).
 *
 * MIRROR of backend/src/shared/validateDate.ts — keep the rule identical in both
 * tiers. Behaviour matches the inline DATE_RE it replaces (/^\d{4}-\d{2}-\d{2}$/):
 * shape-only yyyy-mm-dd (no month/day range check, to preserve prior behaviour).
 *
 * The value is NEVER rewritten/normalised — validate the raw string as typed.
 */

export interface DateValidationResult {
  ok: boolean
  error?: string
}

/** User-facing error. */
export const DATE_ERROR = 'Enter a valid date (yyyy-mm-dd)'

// Identical to the inline DATE_RE this replaces — shape only (yyyy-mm-dd).
export const DATE_RE = /^\d{4}-\d{2}-\d{2}$/

/**
 * Validate an ISO (yyyy-mm-dd) date string. Empty is INVALID here; callers treat
 * the field as optional by skipping validation when it is blank.
 */
export function validateDate(raw: string): DateValidationResult {
  const s = String(raw ?? '').trim()
  if (!s) return { ok: false, error: DATE_ERROR }
  if (!DATE_RE.test(s)) return { ok: false, error: DATE_ERROR }
  return { ok: true }
}

export default validateDate
